import React from 'react';
import styled from 'styled-components';
import { blue6, layoutWhite } from '../../../../../../colors/COLORS';
import PlusIcon from '../../../../../prosemirror/components/icons/plus';
import ButtonTextAtom from '../button-text-atom';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px 10px 14px;
  border-radius: 6px;

  :hover {
    background-color: ${layoutWhite};
  }
`;

interface Props {
  onClick: () => void,
}

const PrivateSpaceButtonMolecule = ({ onClick }: Props) => (
  <Container onClick={onClick}>
    <PlusIcon fill={blue6} />
    <ButtonTextAtom text="Create another Private note" />
  </Container>
);

export default PrivateSpaceButtonMolecule;
